module.exports = __webpack_public_path__ + "media/images/emblems/Chevroux-1de847de8e5c4f02f701b49b6c23dcba.png";